import { render, staticRenderFns } from "./F10.vue?vue&type=template&id=37581ce0&scoped=true"
import script from "./F10.vue?vue&type=script&lang=js"
export * from "./F10.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37581ce0",
  null
  
)

export default component.exports